export default __webpack_public_path__ + "static/media/Anuphan-Medium.60b31dc7.otf";